import api from './api'
import { fallback, staticCredentials } from './fallbackData'
import toast from 'react-hot-toast'

export const authService = {
  async login(credentials) {
    try {
      const response = await api.post('/auth/login', credentials)
      // response is envelope { success, data }
      return response // { user, token }
    } catch (e) {
      toast.error(e.response.data.errors || 'Login failed')
    }
  },

  async logout() {
    try {
      const response = await api.post('/auth/logout', {})
      // response is envelope { success, data }
      return response // { user, token }
    } catch (e) {
      toast.error(e.response.data.errors || 'Logout failed')
    }
  },

  async userRole() {
    try {
      const response = await api.post('/users/roles')
      return response
    } catch (e) {
      throw e
    }
  },

  async register(userData) {
    try {
      const response = await api.post('/auth/register', userData)
      return response.data
    } catch (e) {
      return null
    }
  },

  async getProfile() {
    try {
      const response = await api.get('/auth/profile')
      return response.data
    } catch (e) {
      // Get user from token stored in localStorage
      const token = localStorage.getItem('token')
      if (token && token.startsWith('demo-token-')) {
        const role = token.split('-')[2].toUpperCase()
        const user = Object.values(staticCredentials).find(cred => cred.user.role === role)
        return user ? user.user : fallback.demoUser
      }
      return fallback.demoUser
    }
  },

  async updateProfile(profileData) {
    try {
      const response = await api.put('/auth/profile', profileData)
      return response.data
    } catch (e) {
      return { ...fallback.demoUser, ...profileData }
    }
  },

  async changePassword(passwordData) {
    try {
      const response = await api.put('/auth/change-password', passwordData)
      return response.data
    } catch (e) {
      return null
    }
  },
  async resetPassword(passwordData) {
    try {

      const response = await api.post('/auth/reset-password', passwordData);

      return response;
    } catch (error) {
      toast.error(error.message || 'Something went wrong');
      // throw error;
    }
  },
  async forgetPassword(passwordData) {
    try {
      const response = await api.post('/auth/forget-password', passwordData);
      return response;

    } catch (error) {
      toast.error(error.message || 'Something went wrong');
      throw error;
    }
  },
  async validateToken(passwordData) {
    try {

      const response = await api.post('/auth/validate-token', passwordData);
      return response
    } catch (error) {

      console.log(error, 'sdfgdfg')
      toast.error(error.response.data.errors || 'Something went wrong');
      // throw error;
    }
  },
  async modulePermission(data) {
    try {
      const response = await api.post('/auth/login', data)
      return response
    } catch (e) {
      toast.error(e.response.data.message || 'Failed to get permission')
    }
  },
}